/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：635
 */

var r = require(/* 1240 */"../1581/831/1240")
var o = require(/* 1081 */"../1581/831/1081").concat("length", "prototype")
exports.f = Object.getOwnPropertyNames || function (e) {
  return r(e, o)
}
